import React, { FC } from 'react';

import { useHasMounted } from 'hooks/ssr';

// Fixes the issue where some content is not rendered
// in the correct place after the first render
// https://www.joshwcomeau.com/react/the-perils-of-rehydration/#abstractions
export const ClientOnly: FC = ({ children }) => {
  const hasMounted = useHasMounted();

  if (!hasMounted) {
    return null;
  }

  return <>{children}</>;
};
